// Generated by scripts/mdi/import-questionnaires.mjs from MDI "B12 Injection Intake 09.17.26" (d8dad262-6085-4f18-a384-f7dcdbae968e). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiB12InjectionIntakeAnswerField } from './questions';

export const mdiB12InjectionIntake: FormType<mdiB12InjectionIntakeAnswerField> =
  {
    name: 'B12 Injection Intake',
    validityLength: 25,
    questions: [
      'mdiB12InjectionIntake_hereEvaluatedMedicationHelpProvide',
      'mdiB12InjectionIntake_kidneyDiseaseLiverDiseaseCirrhosis',
      'mdiB12InjectionIntake_suffer',
      {
        key: 'mdiB12InjectionIntake_historyBariatricSurgery',
        next: {
          condition: {
            'mdiB12InjectionIntake_historyBariatricSurgery.lebers_disease': true
          },
          key: 'mdiB12InjectionIntake_urgentDueHavingLebersDisease',
          els: 'mdiB12InjectionIntake_understandQuestionsWereAsked'
        }
      },
      'mdiB12InjectionIntake_urgentDueHavingLebersDisease',
      'mdiB12InjectionIntake_understandQuestionsWereAsked',
      'mdiB12InjectionIntake_importantClickAttachedLinkReview',
      'mdiB12InjectionIntake_elseLikeTellDoctorWho',
      'mdiB12InjectionIntake_complete'
    ]
  };
